import React from 'react';
import { Input } from 'antd';
import s from '../style.module.scss';

const { TextArea } = Input;

// 开放文本题：选填；输入满 maxLength（50）截断不允许继续输入；计数贴纸显示在输入框内部右下角，满额变红
const TextQuestionRow = (props) => {
    const { question, value = '', onChange } = props,
        { code, title, placeholder, maxLength = 50 } = question,
        isFull = value.length >= maxLength;

    return (
        <div className={s['question-row']}>
            {title ? (
                <div className={s['question-title-wrap']}>
                    <span className={s['question-title']}>{title}</span>
                </div>
            ) : null}
            <div className={s['suggestion-wrap']}>
                <TextArea
                    className={s['suggestion-input']}
                    placeholder={placeholder}
                    style={{ height: 96, resize: 'none', padding: '16px 16px 24px', fontSize: '16px', color: '#595959' }}
                    value={value}
                    maxLength={maxLength}
                    onChange={(e) => onChange(code, e.target.value)}
                />
                {/* 计数贴纸：输入框内部右下角，满额时仅当前字数变红，总数保持灰色 */}
                <span className={s['count-badge']}>
                    <span className={isFull ? s['count-badge-full'] : undefined}>{value.length}</span>
                    <span>/{maxLength}</span>
                </span>
            </div>
        </div>
    );
};

export default TextQuestionRow;
